import { IBalancePost, ICardInfo, IPaymentTransaction } from '@/interfaces';
import PaymentService from '@/services/PaymentService';
import { usePaymentMethodStore } from '@/store/usePaymentMethodStore';
import { useSessionStore } from '@/store/useSessionStore';
import { storeToRefs } from 'pinia';
import { computed, ref } from 'vue';
import useToast from './useToast';
import { EPaymentType } from '@/enums';

export default function usePayment() {
  const { toastError } = useToast()
  const pmStore = usePaymentMethodStore()
  const sessionStore = useSessionStore()
  const { currentPaymentMethod } = storeToRefs(pmStore)
  const { currentBalance, session } = storeToRefs(sessionStore)
  const { savePaymentMethod, removePaymentMethod } = pmStore
  const loading = ref(false)
  const submitting = ref(false)

  const hasValidBalance = computed(() => {
    if (!currentPaymentMethod.value) { return true }
    if (currentPaymentMethod.value.payment_type == EPaymentType.credit_card) { return true }
    return currentBalance.value > 0
  })
  const isBalanceLowerThanMinimal = computed(() => {
    return !!(currentPaymentMethod.value
      && currentPaymentMethod.value.payment_type == EPaymentType.balance
      && currentBalance.value < PaymentService.BALANCE_MIN_VALUE)
  })


  const setDefaultPaymentMethod = (lastSelectedCard: ICardInfo | null) => {
    if (currentPaymentMethod.value) return
    const pm = PaymentService.getDefaultPayment(lastSelectedCard, currentBalance.value)
    if (pm) {
      savePaymentMethod(pm)
    }
  }

  const addBalance = async (form: IBalancePost, onSuccess: (transactionId: string) => void) => {

    try {
      submitting.value = true
      const res = await PaymentService.addBalance(form)
      onSuccess(res)
    } catch (error: any) {
      toastError(error)
    } finally {
      submitting.value = false
    }
  }
  const getPmTransaction = async (transactionId: string, onSuccess: (response: IPaymentTransaction) => void) => {
    if (!transactionId) return
    try {
      const res = await PaymentService.getPaymentTransaction(transactionId)
      onSuccess(res)
    } catch (error: any) {
      toastError(error)
    } finally {
      loading.value = false
    }
  }

  return {
    currentPaymentMethod,
    savePaymentMethod,
    removePaymentMethod,
    loading,
    submitting,
    currentBalance,
    addBalance,
    user_document_number: session.value?.document_number,
    setDefaultPaymentMethod,
    getPmTransaction,
    isBalanceLowerThanMinimal,
    hasValidBalance
  }
}
